<div class="chat-panel-container">
  <div class="chat-header">
    <div class="chat-header-inner">
      <button class="new-session-button" (click)="startNewSession()">
        + New Chat
      </button>
    </div>
  </div>

  <div class="chat-body" #chatBody>
    <div class="messages-container">
      <div *ngFor="let msg of messages" class="message-row"
           [ngClass]="{'message-row-user': msg.sender === 'user', 'message-row-agent': msg.sender === 'agent'}">
        <div *ngIf="msg.sender === 'agent'" class="agent-avatar">{{ agentAvatarLabel }}</div>
        <div *ngIf="msg.sender === 'user'" class="user-avatar">{{ userAvatarLabel }}</div>

        <div class="message-bubble" [ngClass]="{'user-message': msg.sender === 'user', 'agent-message': msg.sender === 'agent'}">
          <div class="message-content">
            <div *ngIf="msg.sender === 'agent'">
              <ng-container *ngIf="msg.loading; else agentText">
                <div class="typing-indicator">
                  <span>Thinking</span><div class="dot"></div><div class="dot"></div><div class="dot"></div>
                </div>
              </ng-container>
              <ng-template #agentText>
                <span style="font-size: 20px;" [innerHTML]="msg.formattedText || msg.text"></span>
                <span *ngIf="msg.isStreaming" class="stream-cursor">|</span>
              </ng-template>
            </div>
            <div *ngIf="msg.sender === 'user'" style="font-size: 20px;"[innerHTML]="msg.formattedText || msg.text"></div>
          </div>

          <div *ngIf="msg.files?.length" class="attached-files">
            <div *ngFor="let file of msg.files" class="attached-file">
              <mat-icon>attach_file</mat-icon>
              <span>{{ file.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="chat-footer">
    <div class="input-container">
      <div class="input-wrapper">
        <label class="upload-icon" matTooltip="Upload file (not sent to wrapper yet)">
          <input type="file" multiple (change)="onFileSelected($event)" hidden />
          <mat-icon>attach_file</mat-icon>
        </label>

        <div class="input-content">
          <div *ngIf="selectedFiles.length > 0" class="file-chips">
            <div *ngFor="let file of selectedFiles" class="file-chip">
              <mat-icon>insert_drive_file</mat-icon>
              <span>{{ file.name }}</span>
              <button mat-icon-button (click)="removeFile(file)" matTooltip="Remove">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <textarea #chatInput class="chat-input"
                    placeholder="Type a message..."
                    [(ngModel)]="currentMessage"
                    (input)="autoResizeChatInput()"
                    (keyup.enter)="sendMessageOnEnter($event)"
                    [disabled]="isLoading"
                    rows="2"></textarea>
        </div>
      </div>

      <button class="send-btn" (click)="sendMessage()" mat-icon-button [disabled]="isLoading">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>
